import { Outlet } from 'react-router-dom';
import Header from '../components/layout/Header';
import Newsletter from '../components/layout/Newsletter';
import Footer from '../components/layout/Footer';
import { useEffect, useState } from 'react';
import Enquire from '../components/ui/Enquire';
import AutoScrollLine from '../components/layout/AutoScrollLine';
import BEFModal from '../components/home/BEF';
import { getCollections } from '../services/adminApi';

const DashboardLayout = () => {
  const [collections, setCollections] = useState([])
      const getCollectionData = async () => {
        try {
          const data = await getCollections();
          setCollections(data.data);
        } catch (error) {
          console.log("Some error occured", error);
        }
      }
      useEffect(() => {
        getCollectionData();
      }, []);
  return (
    <div>
      <AutoScrollLine/>
      <Header />
      <main>
        <Outlet />
      </main>
      <Newsletter />
      <BEFModal collections={collections}/>
      <Footer />
      <Enquire/>
    </div>
  );
};

export default DashboardLayout;
